import futbol from "../img/futbol.jpg";
import basquet from "../img/basquet.jpg";
import box from "../img/box.jpg";
import tocho from "../img/tocho.jpg";

// Única fuente de verdad: menú, portada, páginas, panel admin y cotizador salen de aquí.
// Para agregar un deporte basta una línea. imagen: null = portada tipográfica hasta tener foto.
export const DEPORTES = {
    futbol: { id: "futbol", nombre: "Fútbol", corto: "Fútbol", lema: "La pasión en la cancha", imagen: futbol },
    basquet: { id: "basquet", nombre: "Básquet", corto: "Básquet", lema: "Juego aéreo y precisión", imagen: basquet },
    box: { id: "box", nombre: "Box", corto: "Box", lema: "Impacto y resistencia", imagen: box },
    tocho: { id: "tocho", nombre: "Tocho bandera", corto: "Tocho", lema: "Velocidad y estrategia", imagen: tocho },
};

export const DEPORTES_LISTA = Object.values(DEPORTES);
